import { requisitarJson } from '../../../shared/api/http';

export interface GrupoClassificado {
    posicao: number;
    id: string;
    nome: string;
    pontos: number;
}

export interface JogadorClassificado {
    posicao: number;
    id: string;
    nome: string;
    grupo_id: string;
    grupo_nome: string;
    pontos: number;
}

export interface Classificacao {
    turma_id: string;
    /** O que o jogador vê no tablet; a classificação abaixo vale com o ranking travado também. */
    ranking_liberado: boolean;
    grupos: GrupoClassificado[];
    individual: JogadorClassificado[];
}

export function obterClassificacao(turmaId: string): Promise<Classificacao> {
    return requisitarJson(`/api/v1/ranking/classificacao?turma_id=${encodeURIComponent(turmaId)}`);
}

/** «1 ponto» / «N pontos», como o tablet escreve (`ranking.ponto` e `ranking.pontos`). */
export function formatarPontos(pontos: number): string {
    const texto = Number.isInteger(pontos) ? String(pontos) : pontos.toLocaleString('pt-BR');
    return pontos === 1 ? `${texto} ponto` : `${texto} pontos`;
}
